const surveyAnswers = [
  { value: 1, text: 'Rất không đồng ý' },
  { value: 2, text: 'Không đồng ý' },
  { value: 3, text: 'Đồng ý' },
  { value: 4, text: 'Rất đồng ý' },
  { value: 5, text: 'Bỏ trống' },
];

export default surveyAnswers;
